export const CLEAR_CARD_OPERATION_FEES_STORE =
  'CLEAR_CARD_OPERATION_FEES_STORE';
